/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Compare_HintInputs */

const en_salary_compare_hint = /** @type {(inputs: Salary_Compare_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select up to 5 regions to compare salaries adjusted for cost of living.`)
};

const de_salary_compare_hint = /** @type {(inputs: Salary_Compare_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle bis zu 5 Regionen, um Gehälter bereinigt um Lebenshaltungskosten zu vergleichen.`)
};

const fr_salary_compare_hint = /** @type {(inputs: Salary_Compare_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionne jusqu'à 5 régions pour comparer les salaires ajustés au coût de la vie.`)
};

const es_salary_compare_hint = /** @type {(inputs: Salary_Compare_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione hasta 5 regiones para comparar salarios ajustados por costo de vida.`)
};

const it_salary_compare_hint = /** @type {(inputs: Salary_Compare_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona fino a 5 regioni per confrontare gli stipendi adeguati al costo della vita.`)
};

const nl_salary_compare_hint = /** @type {(inputs: Salary_Compare_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecteer maximaal 5 regio's om salarissen gecorrigeerd voor kosten van levensonderhoud te vergelijken.`)
};

const pl_salary_compare_hint = /** @type {(inputs: Salary_Compare_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz do 5 regionów, aby porównać wynagrodzenia skorygowane o koszty utrzymania.`)
};

const fi_salary_compare_hint = /** @type {(inputs: Salary_Compare_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse enintään 5 aluetta vertaillaksesi palkkoja elinkustannuksilla mukautettuna.`)
};

const da_salary_compare_hint = /** @type {(inputs: Salary_Compare_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg op til 5 regioner for at sammenligne lønninger justeret for leveomkostninger.`)
};

const sv_salary_compare_hint = /** @type {(inputs: Salary_Compare_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj upp till 5 regioner för att jämföra löner justerade för levnadskostnader.`)
};

/**
* | output |
* | --- |
* | "Select up to 5 regions to compare salaries adjusted for cost of living." |
*
* @param {Salary_Compare_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_compare_hint = /** @type {((inputs?: Salary_Compare_HintInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Compare_HintInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_compare_hint(inputs)
	if (locale === "fr") return fr_salary_compare_hint(inputs)
	if (locale === "es") return es_salary_compare_hint(inputs)
	if (locale === "it") return it_salary_compare_hint(inputs)
	if (locale === "nl") return nl_salary_compare_hint(inputs)
	if (locale === "pl") return pl_salary_compare_hint(inputs)
	if (locale === "fi") return fi_salary_compare_hint(inputs)
	if (locale === "da") return da_salary_compare_hint(inputs)
	if (locale === "sv") return sv_salary_compare_hint(inputs)
	return en_salary_compare_hint(inputs)
});